export default function BookingTermsContentTh() {
  const p = "text-sm text-dark leading-relaxed mb-3";
  const ulMain = "list-none space-y-4 mb-4 pl-0";
  const liBullet = "text-sm text-dark leading-relaxed";
  const subUl = "list-none space-y-3 mt-2 pl-4 border-l-2 border-gray-200";
  const subLi = "text-sm text-dark leading-relaxed";

  return (
    <div className="px-1">
      <p className="text-base font-bold text-dark mb-1">
        ข้อกำหนดและเงื่อนไขการเข้ารับการอบรมขับขี่ปลอดภัย
      </p>
      <p className="text-sm text-dark mb-6">
        ศูนย์ฝึกขับขี่ปลอดภัยฮอนด้า
      </p>

      <hr className="border-gray-200 mb-6" />

      <h2 className="text-base sm:text-lg font-bold text-dark mb-3">1. มาตรฐานความปลอดภัยและความพร้อม</h2>
      <ul className={ulMain}>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 1.1 สภาพร่างกาย:</p>
          <p className={p}>
            ผู้เข้าอบรมต้องมีสภาพร่างกายและจิตใจที่พร้อมสมบูรณ์ หากมีโรคประจำตัวหรือข้อจำกัดทางสุขภาพที่อาจส่งผลต่อการขับขี่ ต้องแจ้งเจ้าหน้าที่ให้ทราบก่อนเริ่มการอบรมทุกครั้ง
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 1.2 เครื่องแต่งกายและวินัย:</p>
          <p className={p}>
            ต้องแต่งกายรัดกุมตามมาตรฐานที่ศูนย์กำหนด และปฏิบัติตามคำแนะนำของครูฝึกอย่างเคร่งครัด
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 1.3 การตรงต่อเวลา:</p>
          <p className={p}>
            ผู้เข้าอบรมต้องมารายงานตัวตามเวลาที่กำหนด หากล่าช้า ศูนย์ฯ ขอสงวนสิทธิ์ในการพิจารณาการเข้าอบรม
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 1.4 การประเมินความพร้อมและการปรับหลักสูตร:</p>
          <p className={p}>
            เพื่อความปลอดภัยของผู้เข้าอบรม ศูนย์ฝึกขอสงวนสิทธิ์ให้ครูฝึกเป็นผู้ประเมินความพร้อมของผู้เรียน และสามารถปรับเปลี่ยนหรือยกเลิกหลักสูตรได้ หากเห็นว่าผู้เรียนยังไม่พร้อมหรือมีความเสี่ยงต่อการฝึก
          </p>
        </li>
      </ul>

      <h2 className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">2. กฎระเบียบและข้อห้าม</h2>
      <ul className={ulMain}>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 2.1 สิ่งเสพติด:</p>
          <p className={p}>
            ห้ามดื่มสุรา เสพของมึนเมา หรือเล่นการพนันภายในบริเวณศูนย์ฝึกฯ โดยเด็ดขาด
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 2.2 การสูบบุหรี่:</p>
          <p className={p}>
            อนุญาตให้สูบบุหรี่ได้เฉพาะในพื้นที่ที่จัดเตรียมไว้ให้เท่านั้น ห้ามสูบในอาคารหรือสนามฝึก
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 2.3 ข้อบังคับทางกฎหมาย:</p>
          <p className={p}>
            ผู้ที่ไม่มีใบอนุญาตขับขี่หรืออายุต่ำกว่า 15 ปี ห้ามนำยานพาหนะออกสู่ถนนสาธารณะหรือทางหลวงโดยเด็ดขาด
          </p>
        </li>
      </ul>

      <h2 className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">3. การคุ้มครองและขอบเขตความรับผิดชอบ</h2>
      <ul className={ulMain}>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 3.1 ความคุ้มครองประกันภัยอุบัติเหตุ:</p>
          <ul className={subUl}>
            <li className={subLi}>
              <p className={p}>
                <span className="font-medium">○ </span>
                ศูนย์ฝึกฯ ได้จัดทำประกันภัยอุบัติเหตุกลุ่มให้แก่ผู้เข้าอบรม ซึ่งคุ้มครองเฉพาะ อุบัติเหตุที่เกิดขึ้นระหว่างการฝึกซ้อมภายในสนามฝึก ตามวันและเวลาที่กำหนดในหลักสูตรเท่านั้น โดยความคุ้มครองจำกัดเฉพาะ ค่ารักษาพยาบาลภายในวงเงินที่ระบุในกรมธรรม์ประกันภัย และผู้เข้าอบรม ไม่สามารถเรียกร้องค่าเสียหายอื่นใดนอกเหนือจากความคุ้มครองตามกรมธรรม์ดังกล่าวได้
              </p>
            </li>
          </ul>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 3.2 ข้อยกเว้นการคุ้มครอง (สิ่งที่ประกันไม่ครอบคลุม):</p>
          <ul className={subUl}>
            <li className={subLi}>
              <p className="font-medium mb-1">○ อุบัติเหตุภายนอกพื้นที่:</p>
              <p className={p}>
                ไม่คุ้มครองอุบัติเหตุที่เกิดขึ้นระหว่างการเดินทางไป-กลับ หรือนอกพื้นที่สนามฝึกซ้อม
              </p>
            </li>
            <li className={subLi}>
              <p className="font-medium mb-1">○ พฤติกรรมเสี่ยงและละเมิดกฎ:</p>
              <p className={p}>
                ไม่คุ้มครองกรณีอุบัติเหตุเกิดจากการจงใจละเมิดคำสั่งครูฝึก การขับขี่ด้วยความคึกคะนอง หรือภายใต้ฤทธิ์ของมึนเมา
              </p>
            </li>
            <li className={subLi}>
              <p className="font-medium mb-1">○ โรคประจำตัว:</p>
              <p className={p}>
                การเจ็บป่วยหรือการบาดเจ็บที่เกิดจากหรือสืบเนื่องมาจาก โรคประจำตัวของผู้เข้าอบรม รวมถึงโรคหรือภาวะต้องห้ามตามระเบียบของกรมการขนส่งทางบกที่ไม่สามารถขอรับใบอนุญาตขับรถได้
              </p>
            </li>
            <li className={subLi}>
              <p className="font-medium mb-1">○ ความเสียหายต่อทรัพย์สิน:</p>
              <p className={p}>
                ประกันภัยคุ้มครองเฉพาะความเสียหายต่อร่างกาย ไม่รวมถึง ความเสียหายของรถยนต์ หรือทรัพย์สินมีค่าอื่นๆ
              </p>
            </li>
          </ul>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 3.3 การสละสิทธิ์ความรับผิดชอบ:</p>
          <p className={p}>
            กรณีประมาทเลินเล่ออย่างร้ายแรง ผู้เข้าอบรมตกลงรับผิดชอบต่อความเสียหายที่เกิดขึ้นต่อตนเองและทรัพย์สินของศูนย์ฝึกฯ
          </p>
        </li>
      </ul>

      <h2 className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">4. สิทธิ์ของบริษัทและ PDPA</h2>
      <ul className={ulMain}>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 4.1 การปรับเปลี่ยนการอบรม:</p>
          <p className={p}>ศูนย์ฝึกฯ ขอสงวนสิทธิ์ในการปรับเปลี่ยนหรือยกเลิกกำหนดการตามความเหมาะสม</p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 4.2 สิทธิในภาพและข้อมูล:</p>
          <p className={p}>
            ผู้เข้าอบรม ยินยอมให้ศูนย์ฝึกฯ บันทึกภาพนิ่ง ภาพเคลื่อนไหว และเผยแพร่ภาพหรือข้อมูลที่เกี่ยวข้องกับการฝึกซ้อม เพื่อใช้ในการประชาสัมพันธ์ของศูนย์ฝึกฯ ตามนโยบาย PDPA
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 4.3 สิทธิในการส่งต่อข้อมูลให้กรมการขนส่งทางบก:</p>
          <p className={p}>
            ผู้เข้าอบรมตกลงและยินยอมให้ศูนย์ฝึกอบรมส่งต่อข้อมูลผลการอบรม รวมถึงข้อมูลส่วนบุคคลที่เกี่ยวข้องของผู้เข้าอบรมให้แก่ กรมการขนส่งทางบก เพื่อวัตถุประสงค์ในการดำเนินการเกี่ยวกับการออกหรือดำเนินการด้านใบอนุญาตขับขี่ของผู้เข้าอบรม
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 4.4 สิทธิในการเก็บและใช้ข้อมูลเพื่อดำเนินงาน:</p>
          <p className={p}>
            ผู้เข้าอบรมตกลงและยินยอมให้ศูนย์ฝึกอบรมเก็บรวบรวมและใช้ข้อมูลส่วนบุคคลของผู้เข้าอบรมเพื่อการดำเนินงานที่เกี่ยวข้องกับการอบรม
          </p>
        </li>
      </ul>
    </div>
  );
}